module.exports = __webpack_public_path__ + "static/media/woman_on_chair.67cc911c.png";